
const childTag = ['vs-layout', 'vs-main', 'vs-aside', 'vs-footer', 'vs-header']
const isLayout = (opts) => opts && childTag.includes(opts.tag)
const hasChild = (slots, name) => slots.some(child => matchTag(child, name))

const matchTag = (child, name) => {
  const options = child.componentOptions
  const tag = options && options.tag

  return tag ? tag.match(name) : false
}

const childProp = (slots, name, prop) => {
  const node = slots.find(child => matchTag(child, name))
  return node ? node.componentOptions.propsData[prop] != null : false
}

const LayoutAreas = {
  name: 'VsLayoutAreas',
  functional: true,
  render(h, { parent, children }) {
    if (!children.length) return

    const change = {
      hasAside:     hasChild(children, 'vs-aside'),
      stickyHeader: childProp(children, 'vs-header', 'sticky'),
      stickyFooter: childProp(children, 'vs-footer', 'sticky')
    }

    Object.keys(change).forEach(key => {
      if (parent[key] !== change[key]) {
        parent[key] = change[key]
      }
    })

    return children.map(vnode => {
      const options = vnode.componentOptions
      if (!isLayout(options)) return vnode

      const tagName = options.tag.replace(/^vs-/, '')
      const props   = options.propsData || {}
      const vessels = parent.$vessels || {}
      const wrapper = {}

      let areaKey = tagName

      if (tagName == 'aside') {
        areaKey = (props.position || 'left') + 'bar'
      } else if (tagName == 'layout') {
        areaKey = 'main'
      }

      wrapper.class = vessels[areaKey] || {}
      wrapper.class[`layout-${areaKey}`] = true

      return h('div', wrapper, [vnode])
    })
  }
}

export default {
  name: 'VsLayout',
  components: {
    LayoutAreas
  },
  props: {
    mode: {
      type: [String, Object],
      default: 'grid'
    },
    gap: {
      type: [Number, String, Object],
      default: null
    },
    contain: {
      type: [Boolean, Object],
      default: false
    },
    center: {
      type: [Boolean, Object],
      default: true
    },
    fillScreen: {
      type: [Boolean, Object],
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    layout: {
      $attrs: 'all',
      $contain: 'container',
      $center: {
        marginX(value) {
          return value ? 'auto' : null
        }
      },
      $fillScreen: {
        minHeight(value) {
          return value ? 'screen' : null
        }
      }
    },
    header: {
      $stickyHeader: {
        zIndex(value) {
          return value ? 50 : null
        }
      }
    },
    main: {
      $stickyArea: {
        position(value) {
          return value ? 'static' : null
        },
        zIndex(value) {
          return value ? 'auto' : null
        }
      }
    },
    footer: {
      $stickyFooter: {
        zIndex(value) {
          return value ? 50 : null
        },
        pinBottom(value) {
          return value
        },
        position(value) {
          return value ? 'sticky' : null
        }
      }
    },
    leftbar: {
      $gap: {
        paddingRight(value) {
          return this.isGrid ? value : null
        },
        paddingBottom(value) {
          return this.isGrid ? null : value
        }
      }
    },
    rightbar: {
      $gap: {
        paddingLeft(value) {
          return this.isGrid ? value : null
        },
        paddingTop(value) {
          return this.isGrid ? null : value
        }
      }
    }
  },
  data() {
    return {
      hasAside: false,
      stickyHeader: false,
      stickyFooter: false
    }
  },
  computed: {
    classes() {
      return { 'layout': true, [`layout-${this.type}`]: true }
    },
    type() {
      return this.hasAside ? this.$screen.match(this.mode) : 'row'
    },
    isGrid() {
      return this.type == 'grid'
    },
    stickyArea() {
      return this.stickyHeader || this.stickyFooter
    }
  }
}
